import RankingAPI from '@/apis/business/teacher/ranking-api.js'

export default {
  namespaced: true,
  state: {
    students: [],
    topStudents: []
  },

  getters: {

    getStudent (state) {
      return state.student
    }
  },

  mutations: {
    /**
     * @description set dữ liệu cho state classrooms
     * @author NTQyy
     * @param {*} state
     * @param {*} classRooms
     */
    setStudents (state, students) {
      state.students = students
    },

    setTopStudents (state, students) {
      state.topStudents = students
    }

  },

  actions: {

    /**
     * @description Load toàn bộ học sinh màn hình overview
     * @param {*} context
     * @author NVHUY1
     */
    getStudentsOverview (context, param) {
      return new Promise((resolve, reject) => {
        RankingAPI.getAsync('overview', { params: param }).then(res => {
          context.commit('setStudents', res.Data)
          resolve(true)
        }).catch(err => {
          reject(err)
        })
      })
    },

    getTopStudentByClass (context, param) {
      return new Promise((resolve, reject) => {
        RankingAPI.getAsync('top-ranking', { params: param }).then(res => {
          context.commit('setTopStudents', res.Data)
          resolve(true)
        }).catch(err => {
          reject(err)
        })
      })
    }
  }
}
